import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HeaderTemplateData } from '../../dialog/dialog-data.interface';
import { SharedService } from '../../../../services/shared.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GetQuotationByRequestIdGQL, GetRequestActvityAttachmentGQL } from '../../../../generated/cloudapigql';
import { map } from 'rxjs/operators';
import { Utils } from '../../../shared/utils';

export interface quotation extends HeaderTemplateData{
    quotation:any;
    routeOrigin:any;
}

@UntilDestroy()
@Component({
    selector: 'quotation-dialog',
    templateUrl: 'quotation-dialog.html',
    styleUrls: ['quotation-dialog.scss']
})
export class QuotationDialog implements OnInit {
    result: any = [];
    routeOrigin: string;
    header:HeaderTemplateData;
    constructor(
        public dialogRef: MatDialogRef<QuotationDialog>,
        private getQuotationByRequestIdGQL: GetQuotationByRequestIdGQL,
        private getRequestActvityAttachmentGQL: GetRequestActvityAttachmentGQL,
        @Inject(MAT_DIALOG_DATA) public data: quotation,
        public shareService:SharedService,
    ) {
        let att:any =[]
        if(data){
            if(this.data.routeOrigin === 'service-request-listing'){
                this.routeOrigin = 'srl';
                this.header = data;
                this.getQuotationByRequestIdGQL.fetch({
                    requestId: this.data.quotation.ID
                }).pipe(map(x => x.data.serviceRequestById), untilDestroyed(this))
                .subscribe(result => {
                        result.requestActivities?.forEach(x => {
                            if (x.requestQuotation) {
                                let quotation = x.requestQuotation;
                                att.push({
                                    fileName: quotation.attachment?.fileName,
                                    resourceUrl: quotation.attachment?.resourceUrl,
                                    operatorName: quotation.operatorName,
                                    operatorEmail: quotation.operatorEmail,
                                    operatorContactNo: quotation.operatorContactNo,
                                    fileSize:quotation.attachment?.fileSize,
                                    ID:quotation.attachment.ID
                                });
                            }
                        });
                        this.result = att;
                    });
            } else if(this.data.routeOrigin === 'service-request-activities'){
                this.routeOrigin = 'sra';
                this.header = data;
                this.getRequestActvityAttachmentGQL.fetch({
                    input: {
                      refId: this.data.quotation.attachment.refId,
                      refTable: this.data.quotation.attachment.refTable,
                      module: 'servicerequest',
                    }
                  }).pipe(untilDestroyed(this))
                  .subscribe(x => {
                    this.result = x.data.AttachmentByRefIdAndRefTable;
                  })
            }
        }
    }

    ngOnInit() {
       
    }
    
    download(attachment) {
        Utils.downloadFileByUrl(attachment.resourceUrl, attachment.fileName);
        this.shareService.insertDownloadLog(attachment.fileName,attachment.fileSize,location.href,attachment.ID).subscribe();
    }

    mailTo(email: any) {
        window.location.href = `mailto:${email}`;
    }

    callTo(number: string) {
        let contactNo = number.replace(/\D/g, "");
        window.location.href = `tel:${contactNo}`;
    }

    whatsappTo(number: string) {
        let contactNo = number.replace(/\D/g, "");
        window.location.href = `https://api.whatsapp.com/send?phone=${contactNo.slice(1)}`;
    }
}
